import { render } from "./clubActivities.vue?vue&type=template&id=26832162&ts=true"
import script from "./clubActivities.vue?vue&type=script&lang=ts"
export * from "./clubActivities.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__